<template>
  <div class="header">
    <h1>EBC</h1>
    <div class="menu">
      <myMenu></myMenu>
    </div>

    <div class="user" v-if="$store.getters.token || $store.getters.ttoken">
      <span class="userInfo"
        >欢迎您,<span class="name">{{ userData.name }}</span></span
      >
      <span class="btn" @click="openChangePassword = true">修改密码</span>
      <span class="btn" @click="removeUser">注销</span>
    </div>

    <Modal
      v-model="openChangePassword"
      title="修改密码"
      width="350"
      @on-ok="changePassword"
    >
      <i-form
        class="changePassword-form"
        ref="changePasswordData"
        :model="changePasswordData"
        :label-width="80"
      >
        <FormItem prop="userName" label="用户名:">
          {{ changePasswordData.userName }}
        </FormItem>
        <FormItem prop="password" label="原密码:">
          <i-input
            type="password"
            v-model="changePasswordData.password"
            placeholder="Password"
          >
          </i-input>
        </FormItem>
        <FormItem prop="newPassword" label="新密码:">
          <i-input
            type="password"
            v-model="changePasswordData.newPassword"
            placeholder="Password"
          >
          </i-input>
        </FormItem>
        <FormItem prop="password" label="确认密码:">
          <i-input
            type="password"
            v-model="changePasswordData.confirmPassword"
            placeholder="Password"
          >
          </i-input>
        </FormItem>
      </i-form>
    </Modal>
  </div>
</template>
<script>
import myMenu from "./menu.vue";
export default {
  components: {
    myMenu,
  },
  data() {
    return {
      wsOpen: false,
      userData: {},
      openChangePassword: false,

      changePasswordData: {},
      showChangeWechat: false,

      wechatData: false,
    };
  },
  methods: {
    async getInfo() {
      let res = await this.api({
        url: this.$store.getters.token ? "/admin/info" : "/teacher/info",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
      });
      this.userData = res;
      this.changePasswordData = {
        userName: res.userName,
      };
    },

    async changePassword() {
      if (
        this.changePasswordData.newPassword !==
        this.changePasswordData.confirmPassword
      ) {
        this.$Message.error("两次密码不一样");
        this.changePasswordData.password = "";
        this.changePasswordData.newPassword = "";
        this.changePasswordData.confirmPassword = "";
        return;
      }

      await this.api({
        url: this.$store.getters.token
          ? "/admin/updatePasswordWithOld"
          : "/teacher/updatePasswordWithOld",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          oldPassword: this.changePasswordData.password,
          password: this.changePasswordData.newPassword,
          confirmPassword: this.changePasswordData.confirmPassword,
        },
      });
      this.changePasswordData.password = "";
      this.changePasswordData.newPassword = "";
      this.changePasswordData.confirmPassword = "";
      this.$Message.success("密码修改成功");
    },
    removeUser() {
      this.$Modal.confirm({
        title: "确认退出登录？",
        onOk: () => {
          window.localStorage.clear();
          window.location.reload();
        },
        onCancel: () => {},
      });
    },
  },
  mounted() {
    if (this.$store.getters.token || this.$store.getters.ttoken) {
      this.getInfo();
    }
  },
  watch: {
    "$store.getters.token": function (val) {
      if (val) {
        this.getInfo();
      }
    },
    "$store.getters.ttoken": function (val) {
      if (val) {
        this.getInfo();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  height: 60px;
  border-bottom: 1px solid #dcdee2;
  display: flex;
  align-items: center;
  padding: 0 25px;

  h1 {
    font-size: 16px;
    color: #333;
    font-weight: bold;
    width: 160px;
  }

  .console {
    display: flex;
    align-items: center;
  }

  .ws {
    display: flex;
    align-items: center;
    color: #19be6b;
    margin-right: 20px;

    &.disabled {
      color: #ed4014;
    }

    .iconfont {
      margin: 0 5px;
      font-size: 22px;
    }
  }

  .menu {
    margin-left: 54px;
    flex: 1;
    min-width: 830px;
  }

  .user {
    .userInfo {
      margin-right: 20px;
      color: #666;

      .name {
        color: #333;
        font-size: 20px;
      }
    }

    .btn {
      margin-right: 10px;
      color: #5cadff;
      cursor: pointer;

      &:hover {
        color: #2b85e4;
      }
    }
  }
}

.img {
  display: block;
  margin: auto;
}

.tips {
  text-align: center;
  margin-top: 10px;
}
</style>
